import * as olStyle from 'ol/style';
import { getVuetifyThemeVar, getIrMapStrokeColor, getRgbMapStrokeColor } from '@/utils/mapLayerTheme';
import { withOpacity } from '@/utils/map/olColor';

const getThemeVar = getVuetifyThemeVar;

/**
 * RGB 촬영 영역: 경계 헤일로 + 안쪽 파란 채움·테두리
 */
export function rgbImageFeatureStyle() {
  const infoBase = getRgbMapStrokeColor();
  const haloStroke = withOpacity(getThemeVar('--v-info-lighten5', '#ffffff'), 0.9);
  return [
    new olStyle.Style({
      stroke: new olStyle.Stroke({
        color: haloStroke,
        width: 5,
        lineJoin: 'round',
        lineCap: 'round'
      }),
      fill: new olStyle.Fill({ color: 'rgba(0,0,0,0)' })
    }),
    new olStyle.Style({
      stroke: new olStyle.Stroke({
        color: withOpacity(infoBase, 0.9),
        width: 2,
        lineJoin: 'round',
        lineCap: 'round'
      }),
      fill: new olStyle.Fill({
        color: withOpacity(infoBase, 0.22)
      })
    })
  ];
}

/**
 * IR(thermal) 촬영 영역: RGB와 동일 헤일로 패턴
 */
export function thermalImageFeatureStyle() {
  const stroke = getIrMapStrokeColor();
  const haloStroke = withOpacity(getThemeVar('--v-error-lighten5', '#ffffff'), 0.9);
  return [
    new olStyle.Style({
      stroke: new olStyle.Stroke({
        color: haloStroke,
        width: 5,
        lineJoin: 'round',
        lineCap: 'round'
      }),
      fill: new olStyle.Fill({ color: 'rgba(0,0,0,0)' })
    }),
    new olStyle.Style({
      stroke: new olStyle.Stroke({
        color: withOpacity(stroke, 0.9),
        width: 2,
        lineJoin: 'round',
        lineCap: 'round'
      }),
      fill: new olStyle.Fill({
        color: withOpacity(stroke, 0.22)
      })
    })
  ];
}

/**
 * 이미지 클릭 시 IR 위치 사각형 — IR 팔레트 + 가독용 헤일로
 */
export function thermalImageSelectedRectStyles() {
  const stroke = getIrMapStrokeColor();
  const text = getVuetifyThemeVar('--v-text-base', '#1A1D26');
  return [
    new olStyle.Style({
      stroke: new olStyle.Stroke({
        color: withOpacity(text, 0.3),
        width: 5,
        lineJoin: 'round',
        lineCap: 'round'
      }),
      fill: new olStyle.Fill({ color: 'rgba(0,0,0,0)' })
    }),
    new olStyle.Style({
      stroke: new olStyle.Stroke({
        color: withOpacity(stroke, 0.85),
        width: 2.5,
        lineJoin: 'round',
        lineCap: 'round'
      }),
      fill: new olStyle.Fill({
        color: withOpacity(stroke, 0.22)
      })
    })
  ];
}
